"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const url_redirect_decoder_1 = require("./url_redirect_decoder");
exports.urlRedirectDecoder = url_redirect_decoder_1.default;
const url_redirect_encoder_1 = require("./url_redirect_encoder");
exports.urlRedirectEncoder = url_redirect_encoder_1.default;
const url_redirect_strip_tokens_1 = require("./url_redirect_strip_tokens");
exports.urlRedirectStripTokens = url_redirect_strip_tokens_1.default;
const url_redirect_strip_tokens_and_decode_1 = require("./url_redirect_strip_tokens_and_decode");
exports.urlRedirectStripTokensAndDecode = url_redirect_strip_tokens_and_decode_1.default;
exports.urlRedirectTransformers = (leftBracket, rightBracket) => {
    return {
        "urlRedirectDecoder": url_redirect_decoder_1.default(leftBracket, rightBracket),
        "urlRedirectEncoder": url_redirect_encoder_1.default(leftBracket, rightBracket),
        "urlRedirectStripTokens": url_redirect_strip_tokens_1.default,
        "urlRedirectStripTokensAndDecode": url_redirect_strip_tokens_and_decode_1.default(leftBracket, rightBracket),
    };
};
exports.default = exports.urlRedirectTransformers;
//# sourceMappingURL=index.js.map